import { Grid } from '@statsbomb/kitbag-components';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { styled } from 'styled-components';
import { useClearSelections } from '../../hooks/clearSelectionsOnLoad';
import themeHelper from '../../utils/themeHelper';
import MetadataSelections from '../MetadataSelections';

const Container = styled.div`
  padding: ${themeHelper.spacing(1, 0)};
`;

export function MetadataSelection({ onAllValuesProvided }) {
  const { resetSelections } = useClearSelections();
  useEffect(() => {
    resetSelections(onAllValuesProvided);
  }, []);

  return (
    <Container data-testid="metadata-selection">
      <Grid>
        <Grid item xs={2.4}>
          <MetadataSelections.Sport />
        </Grid>
        <Grid item xs={2.4}>
          <MetadataSelections.MatchId id="download-request-match-id" required />
        </Grid>
        <Grid item xs={2.4}>
          <MetadataSelections.MatchPart />
        </Grid>
        <Grid item xs={2.4}>
          <MetadataSelections.Track />
        </Grid>
        <Grid item xs={2.4}>
          <MetadataSelections.Version />
        </Grid>
      </Grid>
    </Container>
  );
}

MetadataSelection.propTypes = {
  onAllValuesProvided: PropTypes.func,
};
MetadataSelection.defaultProps = {
  onAllValuesProvided: undefined,
};

export default { MetadataSelection };
